// extracted by mini-css-extract-plugin
module.exports = {"magazineContent":"MagazineContent_magazineContent__u6ia_","magazineList":"MagazineContent_magazineList__lrcVX"};